
import { isCPF } from "vuetify-masks-br";

import DataComponent from "../../components/DataComponent";
export default {
    components: {DataComponent},
    mixins: [],
    data: () => ({
        dialog: false,
        modalDelete: false,

        show1: false,
        loading: true,
        trocarSenha: false,
        forcaSenha: '',
        senhaValida: false,
        error: '',
        empresas: [],
        empresaSelecionada: null,
        /** Cache de perfis por empresa_id (POST rolesforcompany) */
        rolesByEmpresaCache: {},
        cpfRule: [

            (v) => isCPF(v || "") || "CPF não é válido.",
        ],
        senhaRules1: [
            (v) => !!v || "Senha é obrigatória",
            (v) => /(?=.*\d)(?=.*[a-z])(?=.*[A-Z]).{8,}/.test(v) || 'A senha deve conter letras maisculas, letras minúsculas, números e caracteres especiais(@,$,&...)',
        ],

        usuario: {
            descricao: '',
            title: '',
            name: '',
            id: '',
            email: '',
            password: '',
            telefone: '',
            whatsapp: '',
            picture: '',
            data_nascimento: '',
            cpf_cnpj: '',
            rg: '',
            status: '',
            observacao: '',
            empresa_id: '',
            roles_por_empresa: [],
            empresas :[],

        },
        pagination: [],
        list: [],
        empresasDisponiveis : [],


        search: '',
        filtro_aplicao: 0,
        filtro_empresa: 0,
        aplicacoes: [
            { id: 0, name: 'Todas Aplicações' },
            { id: 1, name: 'StoneUp Admin' },
            { id: 2, name: 'Stone Negativa' },
            { id: 3, name: 'Stone Monitora' },
        ],
        headerEmpresas:[
            { text: 'Id'},
            { text: 'Empresa'},
            { text: 'Perfil de acesso'},
            { text: 'Ações'},
        ],
        headers: [

            { text: 'Nome', value: 'name', align: 'start' },
            { text: 'E-mail', value: 'email', align: 'start' },
            { text: 'Aplicação', value: 'aplicacao', align: 'start' },
            { text: 'Status', value: 'status', align: 'start' },
            { text: 'Empresas', value: 'empresa', align: 'start' },
            { text: 'Perfil (visão lista)', value: 'label', align: 'start' },

            { text: 'Ações', width: "15%", align: 'center', value: '' },
        ],

    }),
    created() {

    },
    mounted() {
        this.listaEmpresas();
        this.getUsers();


    },



    methods: {
        notificacao(title, msg, icon) {
            this.$swal({
                toast: true,
                position: "top-center",
                showConfirmButton: false,
                timer: 3000,
                icon: icon,
                title: title,
                text: msg,
            });
        },
        roleItemsFor(empresaId) {
            const id = Number(empresaId);
            return this.rolesByEmpresaCache[id] || [];
        },
        async ensureRolesForEmpresa(empresaId) {
            const id = Number(empresaId);
            if (!id || this.rolesByEmpresaCache[id]) {
                return;
            }
            try {
                const { data } = await this.$http.post("rolesforcompany", { empresa_id: id });
                this.$set(this.rolesByEmpresaCache, id, data || []);
            } catch (e) {
                console.log(e);
                this.$set(this.rolesByEmpresaCache, id, []);
            }
        },
        mergeEmpresasAndRoles(result) {
            const empresas = result.empresas || [];
            const rpe = result.roles_por_empresa || [];
            return empresas.map((e) => {
                const link = rpe.find((r) => Number(r.empresa_id) === Number(e.id));
                return {
                    id: e.id,
                    name: e.name || e.label,
                    role_id: link ? link.role_id : null,
                };
            });
        },
        removePeriodo(item) {
            let index = this.usuario.empresas.findIndex(
                (old) => old === item
              );

              this.usuario.empresas.splice(index, 1);
          },


          empresaAdd() {

            let empresaSelecionada =this.empresaSelecionada
            if (!empresaSelecionada) {
                this.notificacao("", "Selecione uma empresa para vincular.", "error");
                return;
            }
            empresaSelecionada = {
                id : empresaSelecionada.id,
                name : empresaSelecionada.label,
                role_id: null,
            }

            let index = this.usuario.empresas.findIndex(
              (old) => old.id == empresaSelecionada.id
            );

            if (index === -1) {
              this.usuario.empresas.push(empresaSelecionada);
              this.ensureRolesForEmpresa(empresaSelecionada.id);
            } else {
              this.notificacao("Duplicidade", "O usuário já possui vínculo com esta empresa.", "error");
            }
          },


        limparUsuario() {
            this.rolesByEmpresaCache = {};
            this.usuario = {
                descricao: null,
                title: null,
                name:  null,
                id: null,
                email:  null,
                password:  null,
                telefone: null,
                whatsapp:  null,
                picture:  null,
                data_nascimento:  null,
                cpf_cnpj:  null,
                rg:  null,
                status:  null,
                observacao:  null,
                empresa_id:  null,
                roles_por_empresa: [],
                empresas :[]

            };

        },

        async listaEmpresas() {
            this.empresaId = 1;
             try {
                  this.empresas = [];
                  this.empresaId = 0
                  const { data: result } = await this.$http.get("users/empresasdisponiveis");
                  this.empresas = result;

              }
              catch (exception) {
                  console.log(exception);
              }

        },

        async getUsers() {
            this.loading = true;
            try {
                const { data: result } = await this.$http.get(`usuarios?aplicacao=${this.filtro_aplicao}&empresa=${this.filtro_empresa}`);
                this.list = result;
            } finally {
                this.loading = false;
            }
        },
        verificaForcaSenha() {

        },

        async abriModal(id) {

            this.limparUsuario();

            this.usuario.descricao = id == 0 ? 'Novo usuário' : 'Edição de Usuário'
            if (id != 0) {
                const { data: result } = await this.$http.get("usuarios/" + id)
                this.usuario = result;
                this.usuario.status = this.usuario.status === 'ativo';
                this.usuario.empresas = this.mergeEmpresasAndRoles(result);
                for (const row of this.usuario.empresas) {
                    await this.ensureRolesForEmpresa(row.id);
                }
                this.usuario.alterar_senha = false;
            } else {
                this.usuario.alterar_senha = true;
                this.usuario.id = 0;
                this.usuario.status = true;
                if (this.empresas.length === 1) {
                    const e = this.empresas[0];
                    this.usuario.empresas = [{ id: e.id, name: e.label, role_id: null }];
                    await this.ensureRolesForEmpresa(e.id);
                }
            }


            this.loading = false
            this.dialog = true
        },
        changeStatus() {
            // reservado
        },
        abrirModalInativar(id, texto) {
            this.usuario.id = id
            this.usuario.descricao = texto
            this.modalDelete = true

        },
        formSubmit() {

            this.loading = true;
            this.error = "";
            if (!this.usuario.name || String(this.usuario.name).trim() === "") {
                this.error += '* O nome é obrigatório.'
            }
            if (this.usuario.id == 0) {
                if (!this.usuario.password || String(this.usuario.password).length === 0) {
                    this.error += '\n* A senha é obrigatória para novo usuário.'
                }
            }

            if (!this.usuario.empresas || this.usuario.empresas.length === 0) {
                this.error += '\n* Vincule ao menos uma empresa.'
            } else {
                const semPerfil = this.usuario.empresas.some(
                    (e) => e.role_id === null || e.role_id === undefined || e.role_id === ''
                );
                if (semPerfil) {
                    this.error += '\n* Defina um perfil de acesso para cada empresa vinculada.'
                }
            }

            if (this.error == "") {
                this.criarUsuario();
            } else {
                this.loading = false;
            }
        },
        criarUsuario() {
            this.usuario.id = this.usuario.id === null ? 0 : this.usuario.id;
            this.usuario.alterar_senha =  this.trocarSenha
            this.usuario.roles_por_empresa = this.usuario.empresas
                .filter((e) => e.role_id !== null && e.role_id !== undefined && e.role_id !== '')
                .map((e) => ({
                    empresa_id: Number(e.id),
                    role_id: Number(e.role_id),
                }));
            this.$http.post("usercrud/" + this.usuario.id, {
                data: this.usuario
            }).then(
                (response) => {
                    this.getUsers()
                    this.usuario.descricao = ''
                    this.dialog = false
                    this.loading = false
                    this.notificacao('', response.body, "success")
                },
                (response) => {
                    this.loading = false
                    const msg = (response.body && response.body.message) || (response.data && response.data.message) || 'Erro ao salvar';
                    this.notificacao('', msg, "error")
                }
            );
        },
        descricaoAplicacao(id) {
            var descricao = "Indefinido";
            switch (id) {
                case '1':
                    descricao = "StoneUp Admin";
                    break;
                case '2':
                    descricao = "Stone Negativa";
                    break;
                case '3':
                    descricao = "Stone Monitora"
                    break;
            }
            return descricao;

        },
        formatEmpresasCol(item) {
            const em = item.empresa;
            if (!em || !em.length) {
                return '—';
            }
            if (em.length === 1) {
                return String(em[0].empresa_id != null ? em[0].empresa_id : '');
            }
            return em.length + ' empresas';
        },
        editarMotivo() {
            this.$http.put("finalidades/" + this.usuario.id, {
                descricao: this.usuario.descricao,
                invalidar_titulos: this.usuario.invalidar_titulos,
                contestar_divida: this.usuario.contestar_divida


            }).then(
                (response) => {
                    this.getUsers()
                    this.usuario.descricao = ''
                    this.dialog = false
                    this.notificacao('', response.body.message, "success")
                },
                (response) => {
                    this.notificacao('', response.body.message, "error")
                }
            );
        },
        inativarMotivo() {
            this.loading = true
            this.$http.delete("usuarios/" + this.usuario.id).then(
                (response) => {
                    this.getUsers()
                    this.usuario.descricao = ''
                    this.loading = false
                    this.modalDelete = false
                    const msg = (response.body && response.body.message) || (response.data && response.data.message) || 'Usuário inativado';
                    this.notificacao('', msg, "success")
                },
                (response) => {
                    const msg = (response.body && response.body.message) || (response.data && response.data.message) || 'Erro ao inativar';
                    this.notificacao('', msg, "error")
                    this.loading = false
                    this.modalDelete = false
                }
            );
        }


    },
    watch: {



    }
}
